import React from 'react';
import styles from './ServicioDelivery.module.css';
import RevealOnScroll from './RevealOnScroll';
import delivery from '../../assets/images/delivery.jpg';

export default function ServicioDelivery() {
  return (
    <RevealOnScroll className={styles.root} >
      <div className={styles.inner}>
        
        <div className={styles.text}>
          <h2 className={styles.title}>Servicio de delivery</h2>
          <p className={styles.lead}>
            Mejora la experiencia del cliente  comparte tu link y facilita el cobro de tus entregas.
          </p>
        </div>

        <div className={styles.media}>
          <img
            className={styles.image}
            src={delivery}
            alt="Repartidor entregando paquete"
            loading="lazy"
          />
        </div>
      </div>
    </RevealOnScroll>
  );
}